import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ContentCategoriesLevel3Filter = ({
    loading = false,
    hidden = false,
    options = [],
    filters = {},
    restoreFilterValues,
    onChangeValue = () => {},
}) => (
    <Field
        component={Form.ReduxSelect}
        name='contentCategoriesLevel3'
        hidden={hidden}
        options={options}
        disabled={loading}
        placeholder='3rd level category'
        loading={loading}
        multiple
        selection
        search
        setValue={restoreFilterValues(filters, 'contentCategoriesLevel3')}
        onChangeValue={onChangeValue}
    />
);

ContentCategoriesLevel3Filter.propTypes = {
    loading: PropTypes.bool,
    hidden: PropTypes.bool,
    options: PropTypes.array,
    filters: PropTypes.object,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
};
